import Usuario from './usuario'
import Empresa from './empresa'
import Filial from './filial'

export default class Atualizacao {
  constructor(
    id,
    codigo,
    dataInicio,
    dataFim,
    tipoLeitor,
    tipoAuditoria,
    importado,
    status,
    observacao
  ) {
    this.id = id
    this.codigo = codigo
    this.dataInicio = dataInicio
    this.dataFim = dataFim
    this.tipoLeitor = tipoLeitor
    this.tipoAuditoria = tipoAuditoria
    this.importado = importado
    this.status = status
    this.observacao = observacao
    this.usuario = new Usuario()
    this.empresa = new Empresa()
    this.filial = new Filial()
  }
}
